import React, { useState } from "react";
import { Loading } from "../../../../../../../../Helper/Loading";
 const BrokenImage = 'assets/img/not_found.png'
 
export default function ViewURL({ setshowImagePopup, ImagePopUpData, setipost, ispost, Heading }) {

   
    const [loading, setloading] = useState(true)

    const imageOnLoad = (event) => {

        console.log(`Picture successfully ${event.currentTarget.src} loaded.`);
        if (event.currentTarget.className !== "error") {
            event.currentTarget.className = "success";
            setloading(false)
        }
    };
    const imageOnError = (event) => {
        event.currentTarget.src = BrokenImage;
        event.currentTarget.className = "error";
        setloading(false)
    };

    return (
        <>
            <div className=" modal show fade" style={{ display: "block", backgroundColor: "#00000055", overflow: 'auto' }} tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-md" role="document">
                    <div className="modal-content mx-auto" id='nested' style={{ height: 'auto', width: '40em' }}>
                        <div className="modal-header popheding" id="popupheading">
                            <div className=" ml-4">
                                <span style={{ fontSize: '19px', fontWeight: 'bold' }}>{Heading ? Heading : 'Tree Photo'}</span>
                            </div>

                            <button type="button" className="btn-close mr-3 mt-1" data-dismiss="modal" aria-label="Close" data-backdrop='static'
                                style={{ color: 'white' }}
                                onClick={() => {
                                    setshowImagePopup(false)
                                }}>
                            </button>
                        </div>
                        {loading && <Loading />}
                        <div className="col-12 modal-body mb-3" >
                            <div className="col-12 modal-header justify-content-center" >
                                {
                                    (ImagePopUpData || loading) ?
                                        <img className="col-12 mb-3" style={{ width: "400px", height: "400px" }} src={ImagePopUpData == null ? "ImageNotFound" : ImagePopUpData}
                                            onLoad={imageOnLoad} onError={imageOnError} />
                                        : <img src="./static/assets/Img/not_found.png" />
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}


